export default function BenefitsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-start">
          <div>
            <p className="text-xs md:text-sm font-medium text-primary-600 uppercase tracking-wider mb-2">
              Grundlagen
            </p>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-6">
              Was ist ein OOPBuy Spreadsheet?
            </h2>
            <div className="w-full h-56 md:h-64 rounded-lg overflow-hidden mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20a%20large%20monitor%20displaying%20organized%20spreadsheet%20data%20on%20one%20side%20and%20a%20curated%20selection%20of%20fashion%20items%20including%20a%20folded%20sweater%20and%20sneakers%20on%20the%20other%20side%20of%20a%20light%20oak%20desk%20soft%20natural%20window%20light%20warm%20neutral%20tones%20professional%20yet%20approachable%20editorial%20photography&width=900&height=600&seq=benefits-what-is&orientation=landscape"
                alt="OOPBuy Spreadsheet Übersicht und Produkte"
                title="Was ist OOPBuy Spreadsheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              OOPBuy Spreadsheet ist eine strukturierte Übersicht, mit der Nutzer Produkte schneller entdecken, vergleichen und organisieren können. Statt einzelne Produkte mühsam zu suchen, bietet ein Spreadsheet eine zentrale Sammlung verschiedener Kategorien. Die Plattform wurde entwickelt, um den Einkaufsprozess effizienter zu gestalten und Nutzern eine klare Orientierung im umfangreichen Produktangebot zu bieten.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              Das OOPBuy Spreadsheet System ermöglicht es, fundierte Kaufentscheidungen zu treffen, indem alle relevanten Informationen an einem Ort gebündelt werden. Von detaillierten Produktbeschreibungen über Preisvergleiche bis hin zu Nutzerbewertungen – alles ist übersichtlich strukturiert.
            </p>
          </div>

          <div>
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-6">
              Warum nutzen immer mehr Käufer OOPBuy Spreadsheet?
            </h3>
            <div className="overflow-hidden rounded-lg border border-background-200/70">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-background-200/50">
                    <th className="text-left px-4 py-3 font-semibold text-foreground-900 border-b border-background-200/70">
                      Ohne Spreadsheet
                    </th>
                    <th className="text-left px-4 py-3 font-semibold text-foreground-900 border-b border-background-200/70">
                      Mit OOPBuy Spreadsheet
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-100">
                    <td className="px-4 py-3 text-foreground-600">Lange Suche</td>
                    <td className="px-4 py-3 text-foreground-900 font-medium">Schneller Überblick</td>
                  </tr>
                  <tr className="border-b border-background-100">
                    <td className="px-4 py-3 text-foreground-600">Keine Struktur</td>
                    <td className="px-4 py-3 text-foreground-900 font-medium">Kategorien sortiert</td>
                  </tr>
                  <tr className="border-b border-background-100">
                    <td className="px-4 py-3 text-foreground-600">Schwieriger Vergleich</td>
                    <td className="px-4 py-3 text-foreground-900 font-medium">Einfacher Vergleich</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 text-foreground-600">Weniger Übersicht</td>
                    <td className="px-4 py-3 text-foreground-900 font-medium">Organisierte Daten</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="bg-white rounded-lg p-4 md:p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <h4 className="font-semibold text-foreground-900 text-sm md:text-base mb-1">Zeitersparnis</h4>
                <p className="text-xs md:text-sm text-foreground-500">Produkte schneller finden und vergleichen</p>
              </div>
              <div className="bg-white rounded-lg p-4 md:p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-layout-grid-line text-lg"></i>
                </div>
                <h4 className="font-semibold text-foreground-900 text-sm md:text-base mb-1">Übersicht</h4>
                <p className="text-xs md:text-sm text-foreground-500">Alles organisiert an einem Ort</p>
              </div>
              <div className="bg-white rounded-lg p-4 md:p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-scales-line text-lg"></i>
                </div>
                <h4 className="font-semibold text-foreground-900 text-sm md:text-base mb-1">Vergleich</h4>
                <p className="text-xs md:text-sm text-foreground-500">Mehrere Optionen gleichzeitig prüfen</p>
              </div>
              <div className="bg-white rounded-lg p-4 md:p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-user-smile-line text-lg"></i>
                </div>
                <h4 className="font-semibold text-foreground-900 text-sm md:text-base mb-1">Anfängerfreundlich</h4>
                <p className="text-xs md:text-sm text-foreground-500">Einfacher Einstieg für jeden</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}